const brCharge = {
  charge: {
    title: {
      chargeList: 'Lista de cobranças',
    },

    label: {
      code: 'Código',
      payer: 'Pagador(a)',
      status: 'Status',
      amount: 'Valor',
      type: 'Tipo',
      pay: 'Pagar',
      payUsingBalance: 'Pagar usando saldo',
      confirmPayment: 'Confirmar pagamento',
      appointment: 'Agendamento',
      generateReport: 'Gerar relatório',
      payments: 'Pagamentos',
      show: 'Visualizar',
      total: 'Total',
      totalAmountToPay: 'Total a pagar',
      paySelected: 'Pagar selecionadas',
      chargeReport: 'Relatório de cobranças',
    },

    status: {
      PENDING: 'Pendente',
      RECEIVED: 'Recebido',
      CONFIRMED: 'Confirmado',
      OVERDUE: 'Vencido',
      OTHER: 'Outro',
    },

    types: {
      EVICTION: 'Conferência de Despejo',
      RENT_OUT: 'Rescisão Facilitada',
      FCI: 'FCI',
      SAAS_SUBSCRIPTION: 'Assinatura SaaS',
    },

    hint: {
      fciMeaning: 'Fundo de Conservação de Imóvel',
      fci: 'Pagamento referente ao FCI que a Hauseful adiantou para o fornecedor que realizou a reforma.',
      wantToPay: 'Deseja pagar esta cobrança?',
    },

    messages: {
      successfullyPaid: 'Cobrança paga com sucesso',
      chargeNotFound: 'Nenhuma cobrança encontrada.',
    },
  },
}

export default brCharge
